// src/components/site-editor/panels/ButtonStylePanel.js
import React from 'react';
import { useWebsiteBuilder } from '../../../contexts/WebsiteBuilderContext';
import ButtonStyler from '../../editors/ButtonStyler';

const ButtonStylePanel = () => {
  const { state, actions } = useWebsiteBuilder();
  const { draft } = state;

  const handleButtonStyleChange = (newStyle) => {
    actions.updateDesign('buttonStyle', newStyle);
  };

  const currentColors = draft.design.customColors || {
    primary: '#7C3AED',
    secondary: '#FCD34D',
    background: '#FFFFFF',
    text: '#1F2937',
    accent: '#EC4899'
  };

  const currentButtonStyle = draft.design.buttonStyle || {
    cornerRadius: 'rounded', // 'sharp', 'rounded', 'pill'
    size: 'medium' // 'small', 'medium', 'large'
  };

  return (
    <div className="p-6 space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-slate-900 mb-1">Button Style</h3>
        <p className="text-sm text-slate-600">Customize the look of buttons throughout your site</p>
      </div>

      <ButtonStyler
        buttonStyle={currentButtonStyle}
        onChange={handleButtonStyleChange}
        previewColor={currentColors.primary}
      />

      {/* Button Usage Note */}
      <div className="mt-6 p-4 bg-slate-50 rounded-lg border border-slate-200">
        <h4 className="text-sm font-semibold text-slate-700 mb-2">Where Buttons Appear</h4>
        <ul className="text-xs text-slate-600 space-y-1">
          <li>• "Book a Session" call-to-action</li>
          <li>• Service booking buttons</li>
          <li>• Newsletter signup buttons</li>
          <li>• Contact form submission</li>
        </ul>
      </div>
    </div>
  );
};

export default ButtonStylePanel;
